import { gql } from "@apollo/client";
import { RealtimeInvoiceDetailType } from "../types/RealtimeInvoiceType";

// 复用账期 getByInvoiceId 取 PDF 预览/下载 URL（实时票无 billId，按 invoiceId 查详情）。
export const GET_REALTIME_INVOICE_DETAIL = gql`
    query GetRealtimeInvoiceDetail($invoiceId: ID!) {
        getRealtimeInvoiceDetail(invoiceId: $invoiceId) {
            invoiceId
            status
            pdfPreviewUrl
            pdfDownloadUrl
        }
    }
`;

export interface GetRealtimeInvoiceDetailResponse {
    getRealtimeInvoiceDetail: RealtimeInvoiceDetailType;
}
